// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoTagGroup_wrapper__TfRZN","floor_and_point":"InfoTagGroup_floor_and_point__41Jbw","categories":"InfoTagGroup_categories__mJl34","bar":"InfoTagGroup_bar__nbBYP"};